module.exports = __webpack_public_path__ + "xing.png?5a736a67c99785f2bedda3405de7f482";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xing.png
// module id = 40
// module chunks = 0